module.exports = __webpack_public_path__ + "media/images/city_img/icon6-920ffa6565b05b755e7fb7fdceee61e3.png";